<template >
  <div class="flex justify-center items-center" :class="{'w-2/3': !firstLoad, 'firstLoad': firstLoad}">
    <div class="loader__dots" v-if="type == 1">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>

    <div
      class="loader__round"
      :style="{ width: size + 'em', height: size + 'em' }"
      v-if="type == 2"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    type: Number,
    size: Number,
    firstLoad: Boolean
  },
  name: "Loader",
  mounted() {},
};
</script>

<style scoped>
.loader__dots {
  width: 70px;
  display: inline;
}
.loader__dots > div {
  width: 18px;
  height: 18px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.loader__dots .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
  background-color: #fa5f55;
}

.loader__dots .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
  background-color: #fa5f55;
}

.loader__dots .bounce3 {
  background-color: #fa5f55;
}
@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.loader__round {
  border: 4px #f5f5f5 solid;
  border-top: 4px #fa5f55 solid;
  border-right: 4px #fa5f55 solid;
  border-bottom: 4px #fa5f55 solid;
  border-radius: 50%;
  -webkit-animation: spin 1s infinite linear;
  animation: spin 1s infinite linear;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
